import axios from "axios";

import { Base_URL } from "../url";

// Create new team
export const saveTeam = async (teamData, userName) => {
  try {
    const response = await axios.post(
      `${Base_URL}/TeamMaster/CreateTeam?UserName=${userName}`,
      teamData
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Update team
export const updateTeam = async (teamId, teamData, userName) => {
  try {
    const response = await axios.put(
      `${Base_URL}/TeamMaster/UpdateTeam/${teamId}?UserName=${userName}`,
      teamData
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Add team members
export const addTeamMembers = async (teamId, memberIds, userName) => {
  try {
    const response = await axios.post(
      `${Base_URL}/TeamMaster/AddTeamMembers/${teamId}?UserName=${userName}`,
      memberIds
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Remove team members
export const removeTeamMembers = async (teamId, memberIds, userName) => {
  try {
    const response = await axios.delete(
      `${Base_URL}/TeamMaster/RemoveTeamMembers/${teamId}?UserName=${userName}`,
      {
        data: memberIds,
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Get teams by organization
export const getTeamsByOrg = async (orgId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/TeamMaster/GetTeamsByOrg/${orgId}`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Get team by ID
export const getTeamById = async (teamId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/TeamMaster/GetTeamById/${teamId}`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Get all teams
export const getAllTeams = async () => {
  try {
    const response = await axios.get(`${Base_URL}/TeamMaster/GetAllTeams`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Get team members
export const getTeamMembers = async (teamId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/TeamMaster/GetTeamMembers/${teamId}`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
